export default "__VITE_ASSET__83b749ef__"